import {Button, Input, ToastType} from '@sportcast/ui-react';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {useParams} from 'react-router-dom';
import {MessageProps} from '../../components/alert/Message';
import {setNewPassword} from '../../fetch/passwordApi';
import {ErrorJsonHandlerMap} from '../../fetch/requestErrorHandler';
import './ForgotPassword.scss';
import NewPasswordSet from './NewPasswordSet';
import PasswordStrengthIndicator from './PasswordStrengthIndicator';

const SetNewPassword = () => {
    const [t] = useTranslation();
    const dispatch = useDispatch();
    const {token} = useParams();
    const [password, setPassword] = useState<string>('');
    const [passwordRepetition, setPasswordRepetition] = useState<string>('');
    const [showValidation, setShowValidation] = useState<boolean>(false);
    const [passwordValid, setPasswordValid] = useState<boolean>(false);
    const [showSuccess, setShowSuccess] = useState<boolean>(false);

    const getErrorMessage = () => {
        if (!showValidation || passwordValid) {
            return '';
        }
        if (password !== passwordRepetition) {
            return t('validation.PASSWORD_MISMATCH');
        }
        return t('validation.PASSWORD_STRENGTH');
    };

    const handleClick = () => {
        setShowValidation(true);
        if (!passwordValid) {
            return;
        }

        const statusHandler: ErrorJsonHandlerMap = {
            418: (error) => {
                return {
                    message: t(`error.${error.errorResponse.message.toUpperCase()}`),
                    autoClose: false,
                    type: ToastType.ERROR
                } as MessageProps;
            }
        };

        setNewPassword(token!, password, dispatch, statusHandler).then((response) => {
            if (response.success) {
                setShowSuccess(true);
            }
        });
    };

    if (showSuccess) {
        return <NewPasswordSet/>;
    }

    return (
        <>
            <h5 className="pt-4">{t('forgotPassword.SET_NEW_PASSWORD')}</h5>

            <div className="my-3">
                <PasswordStrengthIndicator
                    onValidate={setPasswordValid}
                    password={password}
                    passwordRepetition={passwordRepetition}
                />
            </div>

            <Input
                id="password"
                className="mb-3"
                type={'password'}
                label={t('forgotPassword.PASSWORD')}
                required={true}
                onChange={(_key, value) => setPassword(String(value))}
                value={password}
            />

            <Input
                id="password-repetition"
                type={'password'}
                label={t('forgotPassword.PASSWORD_REPETITION')}
                required={true}
                onChange={(_key, value) => setPasswordRepetition(String(value))}
                value={passwordRepetition}
                errorMessage={getErrorMessage()}
            />

            <div className="mt-4 text-right">
                <Button
                    id="save"
                    className="w-60"
                    disabled={!password || (!passwordRepetition || passwordRepetition.length < 1)}
                    variant="primary"
                    type="submit"
                    label={t('button.SAVE')}
                    onClick={() => handleClick()}
                />
            </div>
        </>

    );
};

export default SetNewPassword;
